<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Letterhead" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-letterhead-form [letterhead]="letterhead" *ngIf="letterhead"></app-letterhead-form>
        </form>
      </div>
    </section>
  </div>
</div>
